import UIComponent from "../../common/UIComponent";
import "./index.css";
export default class H5CurrentTime extends UIComponent {

  constructor(elementId, interfaces) {
    super()
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();

    this.interfaces.on(VhallPlayer.TIMEUPDATE, () => {
      this.h5currentTime.innerText = this.formatSeconds(this.interfaces.getCurrentTime())
    });

  }

  init() {

    this.h5currentTime = document.createElement("span");
    this.h5currentTime.setAttribute("class", "vhallPlayerh5-currenttime");
    this.h5currentTime.innerText = "00:00";

    this.appendChild(this.elementId, this.h5currentTime);
  }

  formatSeconds(value) {
    var secondTime = parseInt(value);// 秒
    var minuteTime = 0;// 分
    // var hourTime = 0;// 小时
    if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
      //获取分钟，除以60取整数，得到整数分钟
      minuteTime = parseInt(secondTime / 60);
      //获取秒数，秒数取佘，得到整数秒数
      secondTime = parseInt(secondTime % 60);
      //如果分钟大于60，将分钟转换成小时
      // if (minuteTime > 60) {
      //   //获取小时，获取分钟除以60，得到整数小时
      //   hourTime = parseInt(minuteTime / 60);
      //   //获取小时后取佘的分，获取分钟除以60取佘的分
      //   minuteTime = parseInt(minuteTime % 60);
      // }
    }
    return (minuteTime < 10 ? '0' + Math.round(minuteTime) : Math.round(minuteTime)) + ":" + (secondTime < 10 ? '0' + Math.round(secondTime) : Math.round(secondTime))
  }

}